// @flow
import { makeApiCall } from '../apiService/apiService';
import {
  getCookie,
  isBearerTokenPresent,
  redirectToPath,
  resetCookieAndSession,
  strUsables
} from '../helpers';
import config from '../../configs/envConfig';
import openUrls from '../openUrls';
import { PanelConstants } from '../utils';

export const authActions = {
  SET_USER_PROFILE: 'GET_USER_PROFILE',
  TO_BE_DELETED: 'TO_BE_DELETED'
};

export const toBeDeletedTestActionCreator = (text: string) => ({
  type: authActions.TO_BE_DELETED,
  payload: text
});

export const setUserProfile = (data: Object) => ({
  type: authActions.SET_USER_PROFILE,
  payload: data
});

function decideOnLoginFailure(dispatch, encodedCurrentUrl) {
  resetCookieAndSession();
  if (
    window.location.hostname === config.eRetailUrl &&
    (window.location.pathname === '/' || window.location.pathname === '')
  ) {
    redirectToPath(`${config.baseName}${PanelConstants.loginPage}`);
  } else if (openUrls.some(i => window.location.pathname.indexOf(i) > -1)) {
    dispatch(
      setUserProfile({
        error: 'failure',
        authorities: ['ROLE_ANONYMOUS_USER']
      })
    );
  } else if (window.location.pathname.includes(PanelConstants.newPrqPage)) {
    redirectToPath(`${config.baseName}${PanelConstants.loginPage}`);
  } else {
    redirectToPath(`${config.loginUrl}&redirect_url=${encodedCurrentUrl}`);
  }
}

export const getUserProfile = () => (dispatch: Function) => {
  const encodedCurrentUrl = encodeURIComponent(window.location.href);
  if (!isBearerTokenPresent()) {
    decideOnLoginFailure(dispatch, encodedCurrentUrl);
    return null;
  }
  const sessionUserCallObj = {
    method: 'GET',
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'sessionUser',
    successCb: res => {
      dispatch(setUserProfile(res));
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('Getting session user failed ', res);
      decideOnLoginFailure(dispatch, encodedCurrentUrl);
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception while fetching user profile, err= ', res);
      decideOnLoginFailure(dispatch, encodedCurrentUrl);
    }
  };
  return makeApiCall(sessionUserCallObj);
};

// eslint-disable-next-line
export const logout = (data: Object) => (dispatch: Function) => {
  const encodedCurrentUrl = encodeURIComponent(window.location.href);
  const logoutCallObj = {
    method: 'DELETE',
    baseUrl: 'logoutUrl',
    apiEndPoint: 'logout',
    pathVariables: [
      { key: 'authToken', val: getCookie(strUsables.accessToken) }
    ],
    successCb: res => {
      // eslint-disable-next-line no-console
      resetCookieAndSession();
      console.log('Successfully logged out ', res);
      if (data.tenantId === 'ERETL') {
        redirectToPath(config.baseName + PanelConstants.loginPage);
      } else {
        redirectToPath(config.loginUrl);
      }
    },
    failureCb: res => {
      // eslint-disable-next-line no-console
      console.log('Failure in logging out ', res);
      resetCookieAndSession();
      if (data.tenantId === 'ERETL') {
        redirectToPath(config.baseName + PanelConstants.loginPage);
      } else {
        redirectToPath(`${config.loginUrl}&redirect_url=${encodedCurrentUrl}`);
      }
    },
    catchCb: res => {
      // eslint-disable-next-line no-console
      console.log('Exception while logging out, err= ', res);
      resetCookieAndSession();
      if (data.tenantId === 'ERETL') {
        redirectToPath(config.baseName + PanelConstants.loginPage);
      } else {
        redirectToPath(`${config.loginUrl}&redirect_url=${encodedCurrentUrl}`);
      }
    }
  };
  return makeApiCall(logoutCallObj);
};
